import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 're-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.css',
  imports: [RouterOutlet],
})
export class AuthLayoutComponent {}
